(() => {
  const init = () => {
    document.querySelectorAll('[data-am-tabs]:not([data-am-ready])').forEach(root => {
      root.dataset.amReady = 'true';
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const panels = [...root.querySelectorAll('[role="tabpanel"]')];
      const activate = tab => {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(panel => {panel.hidden = panel.id !== tab.getAttribute('aria-controls');});
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();activate(tab);
        });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowDown') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) {event.preventDefault();activate(tabs[next]);tabs[next].focus();}
          if (event.key === ' ') {event.preventDefault();activate(tab);}
        });
      });
    });
    document.querySelectorAll('[data-am-mega]:not([data-am-ready])').forEach(menu => {
      menu.dataset.amReady = 'true';
      let openTimer, closeTimer;
      const clear = () => {clearTimeout(openTimer);clearTimeout(closeTimer);};
      menu.addEventListener('pointerenter', event => {
        clear();
        if (event.pointerType === 'mouse' && window.matchMedia('(min-width: 750px)').matches) {
          openTimer = setTimeout(() => {menu.open = true;}, 140);
        }
      });
      menu.addEventListener('pointerleave', () => {
        clear();
        if (!menu.contains(document.activeElement)) closeTimer = setTimeout(() => {menu.open = false;}, 200);
      });
      const summary = menu.querySelector('summary');
      const collectionLink = summary.querySelector('[data-am-collection-link]');
      summary.addEventListener('click', clear);
      collectionLink?.addEventListener('click', event => {
        clear();
        event.stopPropagation();
        // Preserve ordinary navigation, including modified clicks and new tabs.
      });
      collectionLink?.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          clear();
          menu.open = true;
          menu.querySelector('.am-mega-panel a, .am-mega-panel button')?.focus();
        }
      });
      menu.addEventListener('keydown', event => {if (event.key === 'Escape') clear();});
      menu.addEventListener('focusout', () => {
        setTimeout(() => {
          if (!menu.contains(document.activeElement) && !menu.matches(':hover')) {clear();menu.open = false;}
        }, 0);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

